// extracted by mini-css-extract-plugin
export default {"couponsPage":"style_couponsPage__1xoT3","couponForm":"style_couponForm__PSL-W","formGroup":"style_formGroup__ycpk2"};